<template>
    <a-modal
        :title="infoList.id ? $t('mobileConfig.adv_edit.title' /* 编辑广告 */) : $t('mobileConfig.adv_edit.add_adv' /* 添加广告 */)"
        v-model="visible"
        :width="600"
        :destroyOnClose="true"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-form :form="form">
            <a-form-item style="display: none">
                <a-input v-decorator="['id']" type="hidden"></a-input>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.adv_edit.adv_title' /* 文字轮播内容 */)">
                <a-input
                    v-decorator="['title', { rules: [{ required: true, message: $t('mobileConfig.adv_edit.adv_title_required' /* 请输入文字轮播内容 */) }] }]"
                    :placeholder="$t('mobileConfig.adv_edit.adv_title_required' /* 请输入文字轮播内容 */)"
                ></a-input>
                <div slot="extra">
                    <span class="error-color">{{ $t('mobileConfig.adv_edit.adv_title_tips' /* 字数控制在25个左右 */) }}</span>
                </div>
            </a-form-item>
            <a-form-item :label="$t('mobileConfig.adv_edit.adv_url' /* 跳转地址 */)">
                <a-input
                    v-decorator="['url', { rules: [{ required: false, message: $t('mobileConfig.adv_edit.adv_url_required' /* 请输入链接地址 */) }] }]"
                    :placeholder="$t('mobileConfig.adv_edit.adv_url_required' /* 请输入链接地址 */)"
                ></a-input>
                <div slot="extra">
                    <span class="error-color">{{ $t('mobileConfig.adv_edit.adv_url_tips' /* 格式以 http:// 或 https:// 开头, 不填写则不跳转！ */) }}</span>
                </div>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
const fields = ['id', 'title', 'url'];
import pick from 'lodash.pick';
export default {
    name: 'AdvEdit',
    data() {
        return {
            form: this.$form.createForm(this),
            visible: false,
            infoList: {},
            seatId: null
        };
    },
    methods: {
        show(seatId, record) {
            fields.forEach(v => this.form.getFieldDecorator(v));
            if (!record.id) {
                this.form.resetFields();
            } else {
                this.form.setFieldsValue(pick(record, fields));
            }
            this.visible = true;
            this.infoList = record;
            this.seatId = seatId;
            console.log(seatId);
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    let data = {
                        language: this.$route.params.lang,
                        seat_id: this.seatId,
                        ...values
                    };
                    this.$request.post({ url: 'getMobileAdInfo', data }).then(res => {
                        if (res.code == 200) {
                            this.$message.success($t('web.operate_success' /* 操作成功 */));
                            this.$emit('refresh');
                            this.visible = false;
                            this.form.resetFields();
                        }
                    });
                }
            });
        },
        handleCancel() {
            this.visible = false;
            this.form.resetFields();
        }
    }
};
</script>

<style scoped lang="less"></style>
